import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';

class AssetGroup {
    importToLocation(assetGroupId) {
        const endpoint = formatEndpoint(endpoints.assetGroup.importToLocation);
        return RestManagerWithoutBaseUrl.post(endpoint, { assetGroupId });
    }
}

export default new AssetGroup();
